<div class="z-40" [ngClass]="{ 'dark text-white-dark': store.semidark && store.menu === 'horizontal'}">
    <div class="relative flex w-full items-center border-b border-black/[0.08] bg-white px-5 py-2.5 dark:border-[#253b5c] dark:bg-[#0e1726]">
        @if(user$ | async; as user){ <div
            class="horizontal-logo flex items-center justify-between lg:hidden ltr:mr-2 rtl:ml-2">
            <a routerLink="/" class="main-logo flex shrink-0 items-center">
                <img class="inline w-8 ltr:-ml-1 rtl:-mr-1" src="/assets/images/sc.svg" alt="" />
            </a>

            <a href="javascript:;"
                class="collapse-icon flex flex-none rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-primary dark:bg-dark/40 dark:text-[#d0d2d6] dark:hover:bg-dark/60 dark:hover:text-primary lg:hidden ltr:ml-2 rtl:mr-2"
                (click)="storeData.dispatch({type: 'toggleSidebar'})">
                <icon-menu class="h-5 w-5" />
            </a>
        </div>}

        <div
            [ngClass]="{ 'w-full justify-between': !(user$ | async) }"
            class="flex min-w-0 flex-1 items-center gap-2 dark:text-[#d0d2d6] ltr:ml-auto rtl:mr-auto"
        >
            @if (user$ | async; as user) {
            @if (showGlobalSearch) {
            <div class="flex min-w-0 flex-1 items-center sm:ltr:mr-auto sm:rtl:ml-auto">
                <div
                    class="absolute inset-x-0 top-1/2 z-10 mx-4 hidden w-auto -translate-y-1/2 sm:relative sm:top-0 sm:mx-0 sm:block sm:max-w-xl sm:flex-1 sm:translate-y-0"
                    [ngClass]="{ '!block': search }"
                >
                    <app-search-input
                        [(model)]="headerSearchQuery"
                        widthClass="w-full"
                        size="compact"
                        [placeholder]="'search'"
                        (inputChange)="onHeaderSearch($event)"
                    />
                </div>
                <button
                    type="button"
                    class="search_btn rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 dark:bg-dark/40 dark:hover:bg-dark/60 sm:hidden"
                    (click)="search = !search"
                >
                    <icon-search class="mx-auto h-4.5 w-4.5 dark:text-[#d0d2d6]" />
                </button>
            </div>
            }
            } @else {
            <div class="flex min-w-0 shrink items-center ltr:mr-2 rtl:ml-2">
                <a routerLink="/" class="main-logo flex shrink-0 items-center">
                    <img class="inline ltr:-ml-1 rtl:-mr-1" src="/assets/images/logo.svg" alt="" />
                </a>
            </div>
            }
            <div class="flex shrink-0 flex-wrap items-center gap-2" [ngClass]="showGlobalSearch ? '' : 'ltr:ml-auto rtl:mr-auto'">
                <div class="dropdown shrink-0">
                    <div hlMenu>
                        <button type="button" hlMenuButton
                            class="group relative flex items-center rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60 transition-all duration-200">
                            @if (store.theme === 'light') {
                            <span class="text-gray-500">
                                <icon-sun class="h-5 w-5" />
                            </span>
                            } @else if (store.theme === 'dark') {
                            <span class="text-gray-500">
                                <icon-moon class="h-5 w-5" />
                            </span>
                            } @else if (store.theme === 'system') {
                            <span class="text-gray-500">
                                <icon-laptop class="h-5 w-5" />
                            </span>
                            }
                        </button>
                        <ul *hlMenuItems @toggleAnimation
                            class="top-11 w-[160px] !py-2 font-semibold text-dark dark:text-white-dark dark:text-white-light/90 ltr:right-0 rtl:left-0">
                            <li
                                class="px-2 py-1 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">
                                {{"themeMode" | translate }}
                            </li>
                            <li class="border-t border-gray-100 dark:border-gray-600 my-1"></li>
                            <li>
                                <button *hlMenuItem="let menuItem" (click)="toggleTheme('light')"
                                    class="flex items-center w-full px-3 py-2 text-sm hover:bg-gray-50 dark:hover:bg-gray-300 rounded-md transition-colors"
                                    [class.bg-gray-50]="store.theme === 'light'"
                                    [class.text-gray-600]="store.theme === 'light'"
                                    [class.dark:bg-blue-900/20]="store.theme === 'light'">
                                    <icon-sun class="h-4 w-4 mr-3 rtl:ml-3 text-gray-500" />
                                    {{"light" | translate }}
                                    @if (store.theme === 'light') {
                                    <span class="ml-auto   text-gray-600">
                                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clip-rule="evenodd" />
                                        </svg>
                                    </span>
                                    }
                                </button>
                            </li>
                            <li>
                                <button *hlMenuItem="let menuItem" (click)="toggleTheme('dark')"
                                    class="flex items-center w-full px-3 py-2 text-sm hover:bg-gray-50 dark:hover:bg-gray-300 rounded-md transition-colors"
                                    [class.bg-gray-50]="store.theme === 'dark'"
                                    [class.text-gray-600]="store.theme === 'dark'"
                                    [class.dark:bg-blue-900/20]="store.theme === 'dark'">
                                    <icon-moon class="h-4 w-4 mr-3 rtl:ml-3 text-gray-500" />
                                    {{"dark" | translate }}
                                    @if (store.theme === 'dark') {
                                    <span class="ml-auto   text-gray-600">
                                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clip-rule="evenodd" />
                                        </svg>
                                    </span>
                                    }
                                </button>
                            </li>
                            <li>
                                <button *hlMenuItem="let menuItem" (click)="toggleTheme('system')"
                                    class="flex items-center w-full px-3 py-2 text-sm hover:bg-gray-50 dark:hover:bg-gray-300 rounded-md transition-colors"
                                    [class.bg-gray-50]="store.theme === 'system'"
                                    [class.text-gray-600]="store.theme === 'system'"
                                    [class.dark:bg-blue-900/20]="store.theme === 'system'">
                                    <icon-laptop class="h-4 w-4 mr-3 rtl:ml-3 text-gray-500" />
                                    {{"system" | translate }}
                                    @if (store.theme === 'system') {
                                    <span class="ml-auto   text-gray-600">
                                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clip-rule="evenodd" />
                                        </svg>
                                    </span>
                                    }
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>

                <div
                    class="hidden sm:block w-px h-6 shrink-0 bg-black/[0.08] dark:bg-[#253b5c]"
                    aria-hidden="true"
                ></div>

                <div class="dropdown shrink-0">
                    <div hlMenu>
                        <button type="button" hlMenuButton
                            class="block rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60">
                            {{ store.locale === 'sa' ? 'AR' : store.locale.toUpperCase() }}
                        </button>
                        <ul *hlMenuItems @toggleAnimation
                            class="top-11 grid w-[280px] grid-cols-2 gap-2 !px-2 font-semibold text-dark dark:text-white-dark dark:text-white-light/90 ltr:-right-14 sm:ltr:-right-2 rtl:-left-14 sm:rtl:-left-2">
                            @for (item of store.languageList; track item) {
                            <li>
                                <button *hlMenuItem="let menuItem" type="button" class="w-full hover:text-primary"
                                    [ngClass]="{ 'bg-primary/10 text-primary': translate.getCurrentLang() === item.code }"
                                    (click)="changeLanguage(item)">
                                    <span class="ltr:ml-3 rtl:mr-3">{{ item.name }}</span>
                                </button>
                            </li>
                            }
                        </ul>
                    </div>
                </div>

                <div class="dropdown shrink-0">
                    <div hlMenu class="!block">
                        <button type="button" hlMenuButton class="group relative block">
                            @if (user$ | async; as user) {
                            <span
                                class="w-9 h-9 bg-black dark:bg-white text-white dark:text-black rounded-full grid place-items-center text-sm uppercase">
                                {{ user?.firstName?.[0] }}{{ user?.lastName?.[0] }}
                            </span>
                            }
                        </button>
                        <ul *hlMenuItems @toggleAnimation
                            class="top-11 w-fit !py-0 font-semibold text-dark dark:text-white-dark dark:text-white-light/90 ltr:right-0 rtl:left-0">
                            <li>
                                <div class="flex items-center px-4 py-4">
                                    <div class="flex-none">
                                        @if (user$ | async; as user) {
                                        <span
                                            class="w-10 h-10 bg-black dark:bg-white text-white dark:text-black rounded-sm grid place-items-center text-sm uppercase">
                                            {{ user?.firstName?.[0] }}{{ user?.lastName?.[0] }}
                                        </span>
                                        }
                                    </div>
                                    <div class="truncate ltr:pl-4 rtl:pr-4">
                                        <h4 class="text-base">
                                            @if (user$ | async; as user) {
                                            <span class="capitalize">{{ user?.firstName }} {{ user?.lastName }}</span>
                                            }
                                        </h4>
                                        <a class="text-black/60 hover:text-primary dark:text-dark-light/60 dark:hover:text-white"
                                            href="javascript:;">
                                            @if (user$ | async; as user) {
                                            <span>{{ user?.email }}</span>
                                            }
                                        </a>
                                    </div>
                                </div>
                            </li>
                            <li class="border-t border-white-light dark:border-white-light/10 !flex !items-center !justify-center">
                                <button *hlMenuItem="let menuItem" class="!py-3 space-x-2 text-danger w-fit"
                                    (click)="logout()">
                                    <icon-logout />
                                    <span>{{ 'logout' | translate }}</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- horizontal menu -->
    <ul
        class="horizontal-menu hidden border-t border-[#ebedf2] bg-white px-6 py-1.5 font-semibold text-black dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white-dark lg:space-x-1.5 xl:space-x-8 rtl:space-x-reverse">
        @for (item of navMenuList; track item.label) {
        <li *appHasPermission="item.permission" class="menu nav-item relative">
            @if (!item.isDropdown) {
            <a routerLink="{{item.link}}" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                class="nav-link">
                <div class="flex items-center">
                    <ng-container *ngComponentOutlet="item.icon"></ng-container>
                    <span class="px-2">{{ item.label | translate }}</span>
                </div>
            </a>
            }
            @if (item.isDropdown) {
            <a href="javascript:;" class="nav-link">
                <div class="flex items-center">
                    <ng-container *ngComponentOutlet="item.icon"></ng-container>
                    <span class="px-2">{{ item.label | translate }}</span>
                </div>
                <div class="right_arrow">
                    <icon-caret-down />
                </div>
            </a>
            <ul class="sub-menu">
                @for (subItem of item.submenu; track subItem.label) {
                <li *appHasPermission="subItem.permission">
                    <a routerLink="{{subItem.link}}" routerLinkActive="active">{{ subItem.label | translate }}</a>
                </li>
                }
            </ul>
            }
        </li>
        }
    </ul>
</div>
